import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { gmbApi } from '@/services/gmbApi';

function getUserId() {
  return localStorage.getItem('user_id') || '';
}

export function useGmbAlertNotifications() {
  const queryClient = useQueryClient();
  const userId = getUserId();

  const unreadQuery = useQuery({
    queryKey: ['gmb', 'alerts', 'unread-count', userId],
    queryFn: () => gmbApi.getUnreadAlertCount(userId),
    enabled: !!userId,
    refetchInterval: 60_000,
  });

  const alertsQuery = useQuery({
    queryKey: ['gmb', 'alerts', 'bell', userId],
    queryFn: () => gmbApi.getAlerts(userId, 'all'),
    enabled: !!userId,
    staleTime: 30_000,
  });

  const markAllReadMutation = useMutation({
    mutationFn: () => gmbApi.markAllAlertsRead(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gmb', 'alerts', 'unread-count', userId] });
      queryClient.invalidateQueries({ queryKey: ['gmb', 'alerts', 'bell', userId] });
    },
  });

  const unreadCount = unreadQuery.data?.unread_count ?? 0;
  const alerts = alertsQuery.data?.data?.alerts ?? [];

  return {
    unreadCount,
    alerts,
    isLoading: unreadQuery.isLoading || alertsQuery.isLoading,
    markAllRead: markAllReadMutation.mutate,
    isMarkingAllRead: markAllReadMutation.isPending,
  };
}
